<template>
  <Spinner :size="size" :color="color" :centered="centered" />
</template>

<script>
import Spinner from './Spinner.vue';

export default {
  name: 'SmallSpinner',
  components: {
    Spinner,
  },
  props: {
    size: {
      type: Number,
      default: 50,
    },
    color: {
      type: String,
      default: null,
    },
    centered: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
